import Select from '../../../juristec-ui/core/SelectNew';
import Toggle from '../../../juristec-ui/core/Toggle';
import { fontOptions } from '../../../options';
import { SelectOption } from '../../../types';
import { InputRow, Label, SelectWrapper } from '../styled/DashStyles.styled';

interface TmpData {
  useGlobalFont: boolean;
  fontTitle: string;
  fontLabel: string;
  fontAxis: string;
  fontLegend: string;
  fontInsight: string;
  fontValue: string;
  fontTable: string;
}

interface FontStyleProps<K extends keyof TmpData> {
  tmpData: TmpData;
  handler: (key: string, value: TmpData[K]) => void;
}

const fontOptionsMap = fontOptions.reduce((aux, opt) => {
  aux[opt.value] = opt;
  return aux;
}, {} as Record<string, SelectOption>);

const FontStyle = ({ tmpData, handler }: FontStyleProps<keyof TmpData>) => {
  const handleUseGlobalFont = () => handler('useGlobalFont', !tmpData.useGlobalFont);
  const handleTitle = (val: SelectOption) => handler('fontTitle', val.value);
  const handleLabel = (val: SelectOption) => handler('fontLabel', val.value);
  const handleAxis = (val: SelectOption) => handler('fontAxis', val.value);
  const handleLegend = (val: SelectOption) => handler('fontLegend', val.value);
  const handleInsight = (val: SelectOption) => handler('fontInsight', val.value);
  const handleValue = (val: SelectOption) => handler('fontValue', val.value);
  const handleTable = (val: SelectOption) => handler('fontTable', val.value);

  return (
    <>
      <InputRow>
        <Label>Usar tipografia global</Label>
        <Toggle
          label=""
          checked={tmpData.useGlobalFont}
          handleChange={handleUseGlobalFont}
          styleContainer={{ margin: 'auto 0' }}
          highlightOption={false}
          size="small"
        />
      </InputRow>
      <InputRow disabled={!tmpData.useGlobalFont}>
        <Label>Títulos</Label>
        <SelectWrapper>
          <Select
            label=""
            onChange={handleTitle}
            // @ts-expect-error not typed yet
            value={fontOptionsMap[tmpData.fontTitle]}
            options={fontOptions}
            atModal
          />
        </SelectWrapper>
      </InputRow>
      <InputRow disabled={!tmpData.useGlobalFont}>
        <Label>Rótulos</Label>
        <SelectWrapper>
          <Select
            label=""
            onChange={handleLabel}
            // @ts-expect-error not typed yet
            value={fontOptionsMap[tmpData.fontLabel]}
            options={fontOptions}
            atModal
          />
        </SelectWrapper>
      </InputRow>
      <InputRow disabled={!tmpData.useGlobalFont}>
        <Label>Eixos</Label>
        <SelectWrapper>
          <Select
            label=""
            onChange={handleAxis}
            // @ts-expect-error not typed yet
            value={fontOptionsMap[tmpData.fontAxis]}
            options={fontOptions}
            atModal
          />
        </SelectWrapper>
      </InputRow>
      <InputRow disabled={!tmpData.useGlobalFont}>
        <Label>Legendas</Label>
        <SelectWrapper>
          <Select
            label=""
            onChange={handleLegend}
            // @ts-expect-error not typed yet
            value={fontOptionsMap[tmpData.fontLegend]}
            options={fontOptions}
            atModal
          />
        </SelectWrapper>
      </InputRow>
      <InputRow disabled={!tmpData.useGlobalFont}>
        <Label>Insight</Label>
        <SelectWrapper>
          <Select
            label=""
            onChange={handleInsight}
            // @ts-expect-error not typed yet
            value={fontOptionsMap[tmpData.fontInsight]}
            options={fontOptions}
            atModal
          />
        </SelectWrapper>
      </InputRow>
      <InputRow disabled={!tmpData.useGlobalFont}>
        <Label>Valor</Label>
        <SelectWrapper>
          <Select
            label=""
            onChange={handleValue}
            // @ts-expect-error not typed yet
            value={fontOptionsMap[tmpData.fontValue]}
            options={fontOptions}
            atModal
          />
        </SelectWrapper>
      </InputRow>
      <InputRow disabled={!tmpData.useGlobalFont}>
        <Label>Tabela</Label>
        <SelectWrapper>
          <Select
            label=""
            onChange={handleTable}
            // @ts-expect-error not typed yet
            value={fontOptionsMap[tmpData.fontTable]}
            options={fontOptions}
            atModal
          />
        </SelectWrapper>
      </InputRow>
    </>
  );
};

export default FontStyle;
